import React from 'react';
import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import Participants from '../../components/create/Participants';
import ListingAssistant from '../../components/create/assistant/ListingAssistant';
import CreateDraft from '../../components/create/CreateDraft';
import LocationSearch from '../../components/create/location-search/LocationSearch';
import StarBackground from './components/StarBackground';
import PropertyType from '../../components/create/property-type/PropertyType';
import { useFeatureFlags } from 'src/contexts/FeatureFlagsContext';
import { FeatureFlags } from 'src/flags';
import SetFieldDefaults from '../../components/edit/navigation/SetFieldDefaults';

const Create: React.FC = () => {
  const { hasFeature } = useFeatureFlags();

  const hasSetFieldDefaults = hasFeature(FeatureFlags.NGW_EDIT_MEMBER_DEFAULTS);

  return (
    <Box
      sx={{
        width: '100%',
        flex: 1,
        position: 'relative',
        background: (theme) => theme.palette.background.gradient,
        overflow: 'hidden',
      }}
    >
      {/* Star pattern background */}
      <StarBackground />

      {/* Content container with relative positioning to sit above stars */}
      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          p: 5,
          pt: 0,
          mt: -1,
        }}
      >
        <Box mt={5}>
          <Typography variant="h1" sx={{ color: 'secondary.main' }}>
            Create a Draft Listing
          </Typography>
        </Box>

        {/* Hide the upper create draft on mobile */}
        <Box sx={{ display: { xs: 'none', md: 'block' } }}>
          <CreateDraft />
        </Box>

        <Box sx={{ mt: 2 }}>
          <LocationSearch />

          {/* Grid layout for PropertyType/Participants and ListingAssistant */}
          <Grid container spacing={2}>
            {/* Left column: PropertyType and Participants */}
            <Grid size={{ md: 12, lg: 6 }}>
              <PropertyType highlight={['Residential', 'Residential Lease']} />
              <Participants />
            </Grid>

            {/* Right column: ListingAssistant */}
            <Grid size={{ md: 12, lg: 6 }} sx={{ width: '100%' }}>
              <Box
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <ListingAssistant />
                <Box
                  sx={{
                    mt: 3,
                    display: 'flex',
                    flexDirection: {
                      xs: 'column',
                      md: 'row',
                    },
                    alignItems: {
                      xs: 'flex-start',
                      md: 'center',
                    },
                    justifyContent: 'flex-end',
                  }}
                >
                  {hasSetFieldDefaults && (
                    <SetFieldDefaults
                      showDivider={false}
                      content="Set Defaults"
                      styles={{
                        textTransform: 'capitalize',
                        color: 'grey.500',
                        marginRight: 1,
                      }}
                    />
                  )}
                  <CreateDraft />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default Create;
